import * as c from "/codebuild/output/src3156664917/src/node_modules/lodash/lodash.js";
import { UPDATE_INDIVIDUAL_PREFERENCE as d, GET_ALL_PREFERENCES_SUCCESS as f } from "./types.js";
const s = {
  preferences: new Array()
};
function l(p = s, e) {
  switch (e.type) {
    case f:
      return {
        ...p,
        preferences: e.payload
      };
    case d:
      const r = p.preferences.slice(), n = c.findIndex(r, (o) => o.di_code === e.payload.di_code);
      return n === -1 ? r.push(e.payload) : r[n] = e.payload, console.log(r), {
        ...p,
        preferences: r
      };
    default:
      return p;
  }
}
export {
  l as preferenceReducer
};
//# sourceMappingURL=reducers.js.map
